import { useMutation, useQueryClient } from '@tanstack/react-query'
import MilkingProcessService from 'services/milkingProcessService'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

export const useCreateMilkerMutation = () => {
	const queryClient = useQueryClient()
	const dispatch = useAppDispatch()

	return useMutation({
		mutationFn: ({
			fullName,
			photo,
		}: {
			fullName: string
			photo: File | null
		}) => MilkingProcessService.createMilker(fullName, photo),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['milkers-info'] })
			dispatch(
				notifyUser({
					title: 'Пользователь создан',
					description: '',
					isError: false,
				}),
			)
		},
		onError: () => {
			dispatch(
				notifyUser({
					title: 'Произошла ошибка',
					description: 'Попробуйте снова.',
					isError: true,
				}),
			)
		},
	})
}
